export default "__VITE_ASSET__50bf8414__"